import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Input } from "@revvsales/components";

import { RevvForm } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
  setFlagForCommonFields,
} = DocumentTemplateActions;

class SingleSelectField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      singleSelectFieldValues: this._getDataForPrepopulate(props),
    };
  }

  componentDidMount() {
    this.props.setFlagForDefault(true);
  }

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.SINGLE_SELECT),
    );
    if (propsData.meta) {
      returnData = {
        options: propsData.meta.options,
        default: this._getPreselectedDefaultItem(propsData.meta),
      };
    }
    return returnData;
  };

  _getPreselectedDefaultItem = data => {
    const returnData = [];
    if (data.options && data.options.length > 0) {
      for (let x = 0; x < data.options.length; x += 1) {
        returnData.push(undefined);
        if (data.options[x] === data.default) {
          returnData[x] = true;
        }
      }
    }
    return returnData;
  };

  getDefualtValue = data => {
    let defaultData = "";
    if (data.default.length > 0) {
      for (let v = 0; v < data.default.length; v += 1) {
        if (data.default[v] === true) {
          if (data.options[v] !== "") {
            defaultData = data.options[v];
          }
        }
      }
    }
    return defaultData;
  };

  getDefualtOptions = data => {
    const optionsData = [];
    if (data.options.length > 0) {
      for (let v = 0; v < data.options.length; v += 1) {
        if (data.options[v] !== "") {
          optionsData.push(data.options[v]);
        }
      }
    }
    return optionsData;
  };

  buttonValidation = options => {
    const duplicate = this.showDupPos(options);
    if (duplicate.length > 0) {
      this.props.metaValidStatus(false);
      return;
    }
    let check = false;
    options.forEach(d => {
      if (d === "") {
        check = true;
        this.props.metaValidStatus(false);
      } else if (d !== "" && check === false) {
        this.props.metaValidStatus(true);
        this.props.setFlagForDefault(true);
      }
    });
  };

  showDupPos = arr => {
    let result = [];
    const positions = {};
    // collect all positions
    arr.forEach((value, pos) => {
      positions[value] = positions[value] || [];
      positions[value].push(pos);
    });
    // check how much of same value in string
    Object.keys(positions).forEach(value => {
      const posArray = positions[value];
      if (posArray.length > 1) {
        result = result.concat(posArray);
      }
    });
    return result.sort();
  };
  // console.log(showDupPos(arr));

  render() {
    const { singleSelectFieldValues } = this.state;
    return (
      <React.Fragment>
        {
          <RevvForm
            initialFormValue={singleSelectFieldValues}
            customFieldName="SINGLE_SELECT"
            validateOnChange
            customFieldComponentRules={CustomFieldComponentRules}
            customFieldComponentMessages={CustomFieldComponentMessages}
            render={formProps => {
              const {
                handleChangeInList,
                handleAddToList,
                handleRemoveFromList,
                messages,
                touched,
                errors,
                values,
                isValid,
              } = formProps;
              const allInAll = {
                isValid,
                messages,
                touched,
                errors,
                values,
              };
              this.buttonValidation(values.options);
              const dataCommunication = {
                default: this.getDefualtValue(values),
                options: this.getDefualtOptions(values),
              };
              this.props.setMetaFieldValues(dataCommunication);
              console.debug("allInAll", allInAll, dataCommunication);

              this.updateOptions = () => {
                handleAddToList("options", "");
                handleAddToList("default", false);
              };

              this.removeField = index => {
                handleRemoveFromList("options", index);
                handleRemoveFromList("default", index);
              };

              this.reOrderDefaults = (event, i) => {
                handleChangeInList(event, i);
                // If this is checked then everything else should be unchecked
                if (event.target.checked) {
                  values.default.forEach((defaultValue, index) => {
                    if (i !== index) {
                      // Create a dummy event object since we are dealing with js events in revvform
                      event = { target: { name: "default", checked: false } };
                      handleChangeInList(event, index);
                    }
                  });
                }
              };

              return values.options.map((data, i) => (
                <React.Fragment>
                  <div className="revv-form-items">
                    <div className="custom-feild-formitem">
                      <div className="revvform-label">
                        Value({i + 1})
                        <span className="requiredwitherr-input">*</span>
                      </div>

                      <div className="checkboxpos">
                        <div>
                          <Input
                            name="default"
                            type="checkbox"
                            data-test="SingleSelectField-checkbox"
                            checked={values.default[i]}
                            className="dynamicfieldcustom-footer-input errorborder marright"
                            onChange={event => this.reOrderDefaults(event, i)}
                          />
                          <span className="revvform-label">
                            This is default value
                          </span>
                        </div>
                        {values.options.length > 2 && (
                          <div className="customselect-delete-option">
                            <span
                              className="btn-icon"
                              onClick={() => this.removeField(i)}
                              onKeyPress={() => this.removeField(i)}
                              role="button"
                              tabIndex="0">
                              <FontAwesomeIcon icon={["far", "trash-alt"]} />
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    <Input
                      name="options"
                      type="text"
                      data-test="SingleSelectField-text"
                      value={values.options[i]}
                      placeholder="Enter field value"
                      className="dynamicfieldcustom-footer-input errorborder"
                      onChange={event => handleChangeInList(event, i)}
                    />
                  </div>
                  {values.options.length - 1 === i && (
                    <div className="clause-options-add-option">
                      <Button
                        data-test="checkboxfield-addoption-button"
                        className="revv-btn-secondary-sm"
                        onClick={() => this.updateOptions()}
                        onKeyPress={() => this.updateOptions()}
                        role="button"
                        tabIndex="0">
                        <i>
                          <FontAwesomeIcon
                            icon={["far", "plus-circle"]}
                            className=""
                          />
                        </i>
                        Add another value
                      </Button>
                    </div>
                  )}
                </React.Fragment>
              ));
            }}
          />
        }
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
  setFlagForCommonFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SingleSelectField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/SingleSelectField.js